export enum AlertType {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
  Success = 'success'
}
